import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { FormControl, FormGroup } from 'react-bootstrap';
import { FormErrorFeedback } from '../../Common';
import { EditTopicGroupInfoModal } from './EditTopicGroupInfoModal';

type EditTopicGroupInfoProps = {
  name: string;
  description?: string;
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  preview: boolean;
  isNameInvalid: boolean;
  allowedLanguages: string[];
  isModalOpen: boolean;
  setModalOpen: (isModalOpen: boolean) => void;
};

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 0;
`;

export const EditTopicGroupInfo: FC<EditTopicGroupInfoProps> = ({
  name,
  description,
  setName,
  setDescription,
  preview,
  isNameInvalid,
  isModalOpen,
  setModalOpen,
}) => {
  const { t } = useTranslation('createNewTopic');

  return (
    <>
      <StyledFormGroup>
        <FormControl
          type="text"
          name={'name'}
          value={name}
          data-icom="input-name-ariel"
          data-cy="topic-editor-name"
          disabled={preview}
          onChange={(e) => {
            setName(e.target.value);
          }}
          isInvalid={isNameInvalid}
        />
        {isNameInvalid && <FormErrorFeedback error={t('nameTooShort')} />}
      </StyledFormGroup>
      {isModalOpen && (
        <EditTopicGroupInfoModal
          isModalOpen
          setModalOpen={setModalOpen}
          name={name}
          description={description}
          onSave={(values) => {
            setDescription(values.description);
            setName(values.name);
          }}
        />
      )}
    </>
  );
};
